import { setAttributes } from './dom-attributes';
import { htmlUnescape } from './html-escape';

export function createElement<K extends keyof HTMLElementTagNameMap>(
  type: K,
  attributes: Parameters<typeof setAttributes>[1],
  children?:
    | string
    | Element
    | SVGSVGElement
    | Array<Element | SVGSVGElement>
    | ChildNode,
): HTMLElementTagNameMap[K] {
  const element = document.createElement(type);

  if (typeof children === 'string') {
    element.textContent = children;
  } else if (
    children instanceof Element ||
    children instanceof SVGElement ||
    children instanceof Node
  ) {
    element.append(children);
  } else if (Array.isArray(children)) {
    element.append(...children);
  }

  return setAttributes(element, attributes);
}

export function createSvg(
  attributes: Parameters<typeof setAttributes>[1],
  content: string,
) {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.innerHTML = content;
  return setAttributes(svg, attributes);
}

export function parseElement<K extends keyof HTMLElementTagNameMap>(
  html: string | null | undefined | Element,
  createTag?: K,
  createAttributes: Record<
    string,
    string | number | boolean | object | string[] | number[]
  > = {},
) {
  if (html === null || html === undefined) {
    return html;
  }

  if (typeof html === 'string') {
    if (html.startsWith('html:')) {
      const parsed = htmlUnescape(html.substring('html:'.length));
      const container = createElement('div', {}, parsed);
      container.innerHTML = parsed;
      return container.firstElementChild;
    }

    return createElement(createTag ?? 'span', createAttributes, html);
  }

  return html;
}

export function createSpinner(
  title: string,
  size = 'size-4',
  additional_class_names = '',
) {
  return createSvg(
    {
      class: `animate-spin ${size} inline-block ${additional_class_names}`,
      fill: 'none',
      viewBox: '0 0 24 24',
      role: 'graphics-symbol',
    },
    `<title>${title}</title>
<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>`,
  );
}
